import kendo from '@progress/kendo-ui';

import { AppStorage } from '@/app/shared/services/app-storage/app-storage.js';
let storage = new AppStorage();

export class genericAutoCompleteService {
    constructor(url, param, oldValue = null, extraparam = null, isDepartment = null, sortField, displayName, filterName, extraFilterName, withWarehouseAvailabilityInfo) {
         
        console.log(isDepartment, withWarehouseAvailabilityInfo, extraparam)
        this.data = {
            type: "odata-v4",
            serverFiltering: true,
            error: function (e) {
                console.log(e);
            },
            transport: {
                read: {
                    url: function () {
                        return url
                    },
                    data: {
                        entityTypeId: param,
                        oldValue: oldValue
                    },
                    dataType: "json",
                    xhrFields: {
                        withCredentials: true
                    },
                    beforeSend: function (xhr) {
                        xhr.withCredentials = true;
                        var token = "";
                        if (storage.getItem('Token') != null)
                            token = storage.getItem('Token').Value;
                        xhr.setRequestHeader('Authentication', token);
                    },
                },
                parameterMap: function (options) {

                    if (!options.sort) {
                        options.sort = [{
                            field: sortField, dir: "asc"
                        }]
                    }
                    else if (options.sort.length == 0) {
                        options.sort.push({
                            field: sortField, dir: "asc"
                        })
                    }
                    options.entityTypeId = param;

                    if (options && options.filter && options.filter.filters && options.filter.filters.length > 0) {


                        var paramMap = kendo.data.transports.odata.parameterMap(options);
                        delete paramMap.$inlinecount; // <-- remove inlinecount parameter.
                        delete paramMap.$format; // <-- remove format parameter.

                        paramMap.$filter = paramMap.$filter.replace("tolower(", "").replace(") or", " or");

                        if (paramMap.$filter) {
                            paramMap.$filter = paramMap.$filter.replace(/('[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}')/ig, function (x) {
                                return x.substring(1, x.length - 1);
                            });
                        }
                        var Params = "";

                        Params = paramMap.$filter.split(" or ");

                        paramMap.$filter = "";

                        for (var j = 0; j < Params.length; j++) {
                            if (Params.length == 1 || j == Params.length - 1) {
                                paramMap.$filter = paramMap.$filter + Params[j].replace(/substringof\((.+),(.*?)\)/, "contains(" + 'Name' + ",tolower($1)");
                            }
                        }
                    }
                    return paramMap;

                },
                schema: {
                    data: function (data) {
                        return data.value;
                    },
                    total: function (data) {
                        return data["@odata.count"]; // <-- The total items count is the data length, there is no .Count to unpack.
                    }
                }

            }
        };
    }
}
